<template>
  <div class="text-center">
    <v-bottom-sheet v-model="sheet" persistent>
      <template v-slot:activator="{ on, attrs }">
        <div>
          <!--          <page-header></page-header>-->
          <!-- 제목 -->
          <v-row class="title-wrap">
            <v-col
              cols="12"
              class="icon-title word-type-txt pb-4 d-flex justify-space-between"
            >
              <div>
                <icon-edit :width="24" :height="24" />추가옵션을 입력해 주세요.
              </div>
            </v-col>
          </v-row>
          <!-- 메뉴 -->
          <div class="apply-list px-6">
            <v-text-field
              append-icon="mdi-chevron-right"
              label="대상자명"
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
            <v-text-field label="실접종비"></v-text-field>
            <v-text-field label="신청금액"></v-text-field>
            <v-file-input
              label="첨부파일"
              counter
              multiple
              show-size
              append-icon="mdi-plus-marker"
            ></v-file-input>
          </div>
          <!--하단버튼-->
          <v-bottom-navigation
            v-model="value"
            :input-value="active"
            fixed
            scroll-threshold="500"
            height="96"
          >
            <v-row class="ma-0 py-5 px-6 btn-fixed-wrapper">
              <v-col cols="12">
                <v-btn
                  block
                  elevation="0"
                  class="btn-fixed btn-blue"
                  @click="$emit('goApplMenuList')"
                >
                  <span class="white--text">다음</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-bottom-navigation>
        </div>
      </template>
      <!-- 하단시트 -->
      <v-sheet class="bottom-sheet-box">
        <div class="sheet-title">대상자명</div>
        <div>본인</div>
        <div>배우자</div>
        <!--v-btn class="mt-6" text color="error" @click="sheet = !sheet">
          동의하고 시작하기
        </!--v-btn-->
      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>
<script>
//import PageHeader from '@/components/common/PageHeader.vue';
import IconEdit from '@/assets/customIcon/IconEdit.vue';

export default {
  computed: {},
  components: {
    //  PageHeader,
    IconEdit,
  },

  data: () => ({
    sheet: false,
  }),
};
</script>
